module.exports = __webpack_public_path__ + "img/picture-7.9700b6ee.png";